{
	"title": "Atribución de software de código abierto",
	"backTitle": "Atrás"
}
